import { getTrainerStats } from '@/helpers/trainer'

const getInitialState = () => {
  const emptyStats = getTrainerStats()
  return {
    // stats_stats: emptyStats,

    stats_session: emptyStats,
    stats_session_overview: emptyStats,
    stats_session_result_visible: false,

    stats_hand_alpha: emptyStats,
    stats_hand_beta: emptyStats,
    stats_hand_gamma: emptyStats,
    stats_hand_delta: emptyStats,
  }
}

const getters = {
  // stats_stats: (state) => state.stats_stats,
  stats_session: state => state.stats_session,
  stats_session_overview: state => state.stats_session_overview,
  stats_hand_alpha: state => state.stats_hand_alpha,
  stats_hand_beta: state => state.stats_hand_beta,
  stats_hand_gamma: state => state.stats_hand_gamma,
  stats_hand_delta: state => state.stats_hand_delta,
  stats_session_result_visible: state => state.stats_session_result_visible,
}

function getStatsHandKey(namespace) {
  return namespace.replace('tra/', '')
}

const actions = {
  stats_add_move({ state, commit }, { action, namespace }) {
    const session = getTrainerStats({ stats: state.stats_session, action })
    const key = getStatsHandKey(namespace)
    const hand = getTrainerStats({ stats: state[`stats_hand_${key}`], action })

    commit(`stats_set`, { key: 'stats_session', value: session })
    commit(`stats_set`, { key: `stats_hand_${key}`, value: hand })
  },
  stats_add_hand({ state, commit }, { namespace }) {
    const key = getStatsHandKey(namespace)
    const session = getTrainerStats({
      stats: state.stats_session,
      hands: 1,
      stats_hand: state[`stats_hand_${key}`],
    })
    commit(`stats_set`, { key: 'stats_session', value: session })
  },

  stats_hand_reset({ state, commit }, { namespace }) {
    const key = getStatsHandKey(namespace)
    commit(`stats_reset`, { [`stats_hand_${key}`]: getTrainerStats() })
  },
  stats_session_reset({ state, commit }) {
    commit('stats_reset', { stats_session: getTrainerStats() })
  },
  stats_session_restore({ state, commit }, { stats_session }) {
    commit('stats_reset', { stats_session })
  },
  stats_show_session_result({ state, commit, dispatch }, session) {
    dispatch('hands_clear_timeouts')

    // console.log(session)
    commit(`stats_set`, { key: 'stats_session_overview', value: session })
    commit(`stats_set`, { key: 'stats_session_result_visible', value: true })
  },
}
const mutations = {
  stats_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  stats_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
